import {Component} from 'react'
import LanguageButton from './components/LanguageButton'
import './App.css'

const languageGreetingsList = [
  {
    id: 'bfdf40eb-eec9-4a66-a493-752fe689f0d0',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/multilingual_greeting/english-greetings-img.png',
    buttonText: 'English',
    imageAltText: 'english',
  },
  {
    id: '0ceda891-2a0c-49e2-8c62-68e78180bac6',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/multilingual_greeting/tamil-greetings-img.png',
    buttonText: 'Tamil',
    imageAltText: 'tamil',
  },
  {
    id: '89537778-7a46-4c58-988c-0adc931d087c',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/multilingual_greeting/telugu-greetings-img.png',
    buttonText: 'Telugu',
    imageAltText: 'telugu',
  },
]

// Replace your code here
class App extends Component {
  state = {
    activeBtnId: 'bfdf40eb-eec9-4a66-a493-752fe689f0d0',
  }

  updateLanguageBtn = id => {
    this.setState({activeBtnId: id})
  }

  renderImageElement = () => {
    const {activeBtnId} = this.state
    const imageDetails = languageGreetingsList.find(
      each => each.id === activeBtnId,
    )
    return imageDetails
  }

  render() {
    const {activeBtnId} = this.state
    const imageDetails = this.renderImageElement()
    const {imageUrl, imageAltText} = imageDetails
    return (
      <div className="bg-container">
        <h1 className="main-heading">Multilingual Greetings</h1>
        <ul className="btns-container">
          {languageGreetingsList.map(eachItem => (
            <LanguageButton
              btnDetails={eachItem}
              isActive={activeBtnId === eachItem.id}
              updateLanguageBtn={this.updateLanguageBtn}
              key={eachItem.id}
            />
          ))}
        </ul>
        <img src={imageUrl} alt={imageAltText} className="main-img" />
      </div>
    )
  }
}

export default App
